declare var window: any

const isMobile = () => {
  return window.innerWidth < 650
}

export default isMobile
